import React, { createContext, useState, useMemo } from "react"

export const SideBarContext = createContext(null)

export const SideBarContextProvider = ({ children }) => {
  const [bSideBarIsOpen, fnSetBSideBarIsOpen] = useState(false)
  const [bSideBarOnAfterOpen, fnSetBSideBarOnAfterOpen] = useState(false)
  const [bSideBarOnAfterClose, fnSetBSideBarOnAfterClose] = useState(false)

  const value = useMemo(() => {
    return {
      bSideBarIsOpen,
      fnSetBSideBarIsOpen,
      bSideBarOnAfterOpen,
      fnSetBSideBarOnAfterOpen,
      bSideBarOnAfterClose,
      fnSetBSideBarOnAfterClose,
    }
  }, [bSideBarIsOpen, bSideBarOnAfterOpen])

  return <SideBarContext.Provider value={value}>{children}</SideBarContext.Provider>
}

export default SideBarContext
